import { useContext } from 'react';
import OrganizationContext from '../contexts/OrganizationContext';

// get the organization we're currently viewing
export default function useOrganization() {
  const org = useContext(OrganizationContext);

  return ({
    ...org,
    organizationId: org.id, // easier to consume w/ explicit naming
    isBusiness: org.is_business, // avoid eslint errors
    isEnterprise: org.enterprise
  });
}
